import React, { useEffect, useState } from "react";

function getBrandName() {
  const hostname = window.location.hostname.replace(/^www\./i, "").toLowerCase();
  if (hostname === "dailydoseofdeal.com") {
    return "Daily Dose of Deal";
  }
  return "YMMV Deals";
}

export default function AffiliateDisclosure() {
  const [brand, setBrand] = useState("YMMV Deals");

  useEffect(() => {
    setBrand(getBrandName());
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center text-indigo-700 drop-shadow-md tracking-wide">Affiliate Disclosure</h1>
      <p className="mb-4">
        Some of the links on <strong>{brand}</strong> are affiliate links. This means that if you click on a link and make a purchase, we may earn a commission at no extra cost to you.
      </p>
      <p>
        We only recommend products and services that we believe will add value to our users.
      </p>
    </div>
  );
}
